import type { ResourceGroup } from '../types/resources'
import { site } from './site'

export const resourceGroups: ResourceGroup[] = [
  {
    id: 'officiel',
    title: 'Sources officielles Goelst',
    description:
      'Les références à consulter en priorité pour les informations produits, les visuels et les coordonnées de Goelst France S.A.R.L.',
    links: [
      { name: 'Site international Goelst', url: site.website },
      { name: 'Instagram — @goelst_international', url: site.instagram },
    ],
  },
  {
    id: 'annuaires-fr',
    title: 'Annuaires professionnels français',
    description:
      'Fiches d’entreprise publiées sur les principaux annuaires français, utiles pour vérifier l’adresse, le téléphone et l’activité « rails à rideaux ».',
    links: [
      { name: 'EnrollBusiness France', url: 'https://fr.enrollbusiness.com/BusinessProfile/7953200/' },
      {
        name: 'Hotfrog France',
        url: 'https://www.hotfrog.fr/company/97c29548e44c5d1fee2d12b983972fea/goelst-france-s-a-r-l/brignoles/home-improvement',
      },
      { name: 'Acompio France', url: 'https://www.acompio.fr/Goelst-France-SARL-47826120.html' },
      {
        name: 'Infobel France',
        url: 'https://www.infobel.com/fr/france/goelst_france_s_a_r_l/brignoles/FR114326314-0494697428/businessdetails.aspx',
      },
      { name: 'Infoisinfo Brignoles', url: 'https://brignoles.infoisinfo.fr/fiche/goelst-france-s-a-r-l/3536183' },
      { name: 'MisterWhat France', url: 'https://www.misterwhat.fr/company/2724648-goelst-france-sarl-brignoles' },
      { name: 'Cylex Locale France', url: 'https://www.cylex-locale.fr/entreprises/goelst-france-s-a-r-l-34611141.html' },
      { name: 'Pages-24 Brignoles', url: 'https://www.pages-24.fr/brignoles/goelst-france-sarl-aYGhR0.html' },
      { name: 'Firmania France', url: 'https://firmania.fr/brignoles/goelst-france-sarl-3819318' },
      { name: 'Trouver-Ouvert', url: 'https://trouver-ouvert.fr/brignoles/goelst-france-sarl-3527481' },
      {
        name: 'Cataloxy Provence-Alpes-Côte d’Azur',
        url: 'https://provence-alpes-cote-dazur-province.cataloxy.org/firms/var/goelst-international.com.htm',
      },
      { name: 'Tellows France — vérification du numéro', url: 'https://www.tellows.fr/num/%2B33494697428' },
      {
        name: 'Locanto France',
        url: 'https://www.locanto.fr/la-valette-du-var/ID_9389620237/Goelst-France-S-A-R-L-Brignoles.html',
      },
    ],
  },
  {
    id: 'cartes',
    title: 'Cartes et référencement local',
    description:
      'Localisation de l’atelier au 869 Avenue des Chênes Verts et fiches géolocalisées pour préparer une visite ou un rendez-vous sur site.',
    links: [
      { name: 'Foursquare Places', url: 'https://business.foursquare.com/places/6a9e626a2835205cfb312dc9' },
      { name: 'AskMap', url: 'http://www.askmap.net/location/7938152/france/goelst-france-s.a.r.l' },
      { name: 'Scribble Maps', url: 'https://www.scribblemaps.com/maps/view/Goelst-France-SARL/goelstinternational' },
      { name: 'ZeeMaps', url: 'https://www.zeemaps.com/map/oqndy?group=7163024' },
      {
        name: 'Nextdoor Brignoles',
        url: 'https://fr.nextdoor.com/page/goelst-france-sarl-brignoles-provence-alpes-cote-dazur',
      },
      { name: 'Wanderboat', url: 'https://wanderboat.ai/posts/goelst-france-s.a.r.l/ggr44MoNRxeScIEVpu4gbw' },
      {
        name: 'Where2Go',
        url: 'https://where2go.com/binn/b_search.w2g?function=detail&type=quick&listing_no=2219637&_UserReference=7F00000146B418D1B4891C7619726A9E5D59',
      },
      {
        name: 'WhatsYourHours',
        url: 'https://www.whatsyourhours.com/france/brignoles/business-services/goelst-france-s-a-r-l',
      },
    ],
  },
  {
    id: 'rendez-vous',
    title: 'Prise de rendez-vous',
    description:
      'Plateformes de réservation utilisées pour organiser un échange technique, une présentation de gamme ou une visite de projet.',
    links: [
      { name: 'Reservio', url: 'https://goelst-france-s-a-r-l.reservio.com/' },
      { name: 'Setmore', url: 'https://goelstfrancesarl.setmore.com/' },
      { name: 'SimplyBook', url: 'https://goelstinternational.simplybook.it/v2/' },
      { name: 'Bark France', url: 'https://www.bark.com/fr/fr/company/goelst-france-sarl/9Xzk3B/' },
    ],
  },
  {
    id: 'b2b',
    title: 'Plateformes B2B et industrielles',
    description:
      'Références professionnelles orientées prescripteurs, acheteurs et fournisseurs pour les projets d’équipement de rails à rideaux.',
    links: [
      { name: 'Europages', url: 'https://www.europages.co.uk/en/company/goelst-france-sarl-22414780' },
      { name: 'B2BCo', url: 'https://www.b2bco.com/goelstinternational/' },
      { name: 'EC21', url: 'https://goelstinternational.en.ec21.com/company_info.html' },
      { name: 'DealerBaba', url: 'https://www.dealerbaba.com/suppliers/goelst-france-sarl-mtqpabmt' },
      { name: 'Dibiz', url: 'https://www.dibiz.com/goelstinternational' },
      { name: 'Trepup', url: 'https://www.trepup.com/store/goelstinternationa/profile' },
      { name: 'Startupxplore', url: 'https://startupxplore.com/en/startups/goelst-france-s-a-r-l' },
      { name: 'Express Business Directory', url: 'https://www.expressbusinessdirectory.com/directory/goelst-france-s-a-r-l/' },
      { name: 'Business Listing Plus', url: 'https://businesslistingplus.com/profile/goelst-france-sarl/' },
      { name: 'ReleaseWire Connect', url: 'https://connect.releasewire.com/company/goelst-france-sarl-361493.htm' },
      { name: 'LinkCentre', url: 'https://www.linkcentre.com/profile/goelstfrancesarl/' },
      { name: 'Storeboard', url: 'https://www.storeboard.com/goelstfrancesarl' },
    ],
  },
  {
    id: 'annuaires-int',
    title: 'Annuaires internationaux et locaux',
    description:
      'Fiches complémentaires reprenant l’activité et les coordonnées de la société sur des annuaires généralistes.',
    links: [
      { name: 'Brownbook', url: 'https://www.brownbook.net/business/55481370/goelst-france-sarl' },
      { name: 'Tupalo', url: 'https://www.tupalo.net/en/brignoles/goelst-france-s-a-r-l' },
      { name: 'BizRatings', url: 'https://www.bizratings.com/goelst-france-sarl' },
      { name: 'Verview', url: 'https://verview.com/biz/10101359-goelst-france-sarl-brignoles-provence-alpes-cote-dazur' },
      { name: 'Flokii', url: 'https://flokii.com/businesses/view/164508/goelst-france-s-a-r-l' },
      { name: 'Trueen', url: 'https://trueen.com/business/listing/goelst-france-s-a-r-l/793873' },
      { name: 'LetsKnowIt', url: 'https://letsknowit.com/goelst183100' },
      { name: 'Blinx', url: 'https://www.blinx.biz/goelst-france-sarl' },
      {
        name: 'EarthMom',
        url: 'https://www.earthmom.org/brignoles-provence-alpes-c%C3%B4te-d-azur/home-services/goelst-france-s-a-r-l',
      },
      { name: 'AddonBiz', url: 'https://www.addonbiz.com/listing/869-avenue-des-chenes-verts-brignoles-provence-alpes-cote-dazur-83170-goelst-france-s-a-r-l/' },
      { name: 'SurfYourTown', url: 'https://www.surfyourtown.com/brignoles/shopping/goelst-france-s-a-r-l' },
      { name: 'SayEllow', url: 'https://www.sayellow.com/view/france/goelst-france-s-a-r-l-in-brignoles' },
      { name: 'BestDealFinder', url: 'http://www.bestdealfinder.com/france/brignoles/home-services/goelst-france-s-a-r-l' },
      { name: 'BestInCom', url: 'https://www.bestincom.com/brignoles/contractors/goelst-france-s-a-r-l' },
      {
        name: 'BizBangBoom',
        url: 'https://www.bizbangboom.com/brignoles-provence-alpes-c%C3%B4te-d-azur/business-services/goelst-france-s-a-r-l',
      },
      {
        name: 'BizBuildBoom',
        url: 'https://www.bizbuildboom.com/brignoles-provence-alpes-c%C3%B4te-d-azur/business-services/goelst-france-s-a-r-l',
      },
      {
        name: 'BizToBiz',
        url: 'https://www.biztobiz.org/brignoles-provence-alpes-c%C3%B4te-d-azur/business-services/goelst-france-s-a-r-l',
      },
      {
        name: 'BigBizStuff',
        url: 'https://www.bigbizstuff.com/brignoles-provence-alpes-c%C3%B4te-d-azur/business-services/goelst-france-s-a-r-l',
      },
      {
        name: 'SmallBizBlog',
        url: 'https://www.smallbizblog.net/brignoles-provence-alpes-c%C3%B4te-d-azur/business-services/goelst-france-s-a-r-l',
      },
      {
        name: 'Choice Directory',
        url: 'https://www.choice.directory/brignoles-provence-alpes-c%C3%B4te-d-azur/business-consultants/goelst-france-s-a-r-l',
      },
      { name: 'BizCoupon Directory', url: 'https://www.bizcoupon.directory/france/brignoles/home-services/goelst-france-s-a-r-l' },
      {
        name: 'YPLocal',
        url: 'https://www.yplocal.com/brignoles-provence-alpes-c%C3%B4te-d-azur/business-professional-services/goelst-france-s-a-r-l',
      },
      {
        name: 'WeGotAGuy',
        url: 'https://www.wegotaguy.net/shopping/brignoles/provence-alpes-c%C3%B4te-d-azur/goelst-france-s-a-r-l',
      },
      { name: 'Warrior Biz Network', url: 'https://www.warriorbiznetwork.com/france/brignoles/retail/goelst-france-s-a-r-l' },
      {
        name: 'Isokorigari',
        url: 'https://www.isokorigari.com/brignoles-provence-alpes-c%C3%B4te-d-azur/shopping-and-retail/goelst-france-s-a-r-l',
      },
      {
        name: 'IBI Directories',
        url: 'https://www.ibidirectories.com/france/brignoles-provence-alpes-c%C3%B4te-d-azur/ibi-categories/goelst-france-s-a-r-l',
      },
      {
        name: 'Wireanium',
        url: 'https://www.wireanium.com/france/brignoles/product-and-industrial-designers/goelst-france-s-a-r-l',
      },
      {
        name: 'Globale Connections',
        url: 'https://www.globaleconnections.com/france/brignoles-provence-alpes-c%C3%B4te-d-azur/shopping/goelst-france-s-a-r-l',
      },
      { name: 'SuccessCenter', url: 'https://www.successcenter.com/brignoles/product/goelst-france-s-a-r-l' },
      { name: 'CityBestAwards', url: 'https://citybestawards.com/biz/goelst-france-s-a-r-l?redirect=%2Fbiz%2Fgoelst-france-s-a-r-l' },
    ],
  },
  {
    id: 'avis',
    title: 'Avis et vérification',
    description:
      'Pages sur lesquelles les retours d’expérience et les vérifications d’entreprise sont centralisés par des tiers indépendants.',
    links: [
      { name: 'ProvenExpert', url: 'https://www.provenexpert.com/goelst-france-s-a-r-l/?mode=preview' },
      {
        name: 'Trustindex',
        url: 'https://www.trustindex.io/reviews/goelst-international.com?_gl=1*wbqv1*_gcl_au*MTQxOTkyOTMwNi4xNzg4NzUxNDE2LjE3ODc5NzA0MDcuMTc4ODc1MzEwMy4xNzg4NzUzMTA1LjE0OTI3MDQ4NDYuMTc4ODc1MzEwMy4xNzg4NzUzMTA2*_ga*MTgwMTA5NDkwNy4xNzg4NzUxNDE1*_ga_DGL6KLFTVT*czE3ODg3NTE0MTQkbzEkZzEkdDE3ODg3NTM0MjkkajYkbDAkaDE1MDU3ODMzMzg.',
      },
      { name: 'Trustburn', url: 'https://trustburn.com/reviews/goelst-international-com' },
    ],
  },
  {
    id: 'medias',
    title: 'Médias, publications et réseaux',
    description:
      'Publications, documents et profils sociaux où l’activité et les projets de rails à rideaux sont présentés plus librement.',
    links: [
      { name: 'Medium', url: 'https://medium.com/@goelstinternational/goelst-france-s-a-r-l-6b388017f1bf' },
      { name: 'Issuu', url: 'https://issuu.com/goelstinternational' },
      { name: 'Speaker Deck', url: 'https://speakerdeck.com/goelstinternational' },
      { name: 'Wakelet', url: 'https://wakelet.com/@GoelstFranceSARL61583' },
      { name: 'Penzu', url: 'https://penzu.com/public/86e87efe54a22a8d' },
      { name: 'JustPaste.it', url: 'https://justpaste.it/goelstinternational' },
      { name: 'Pastelink', url: 'https://pastelink.net/66vrgjgo' },
      { name: 'Disqus', url: 'https://disqus.com/by/goelstfrancesarl/' },
      { name: 'Zumvu', url: 'https://zumvu.com/goelstinternational/' },
      { name: 'Solo.to', url: 'https://solo.to/goelstinternational' },
      { name: 'Shor.by', url: 'https://shor.by/goelstinternational' },
      { name: 'Bio.so', url: 'https://bio.so/goelstinternational/' },
      { name: 'Blurb', url: 'https://www.blurb.com/user/goelstintern?profile_preview=true' },
      { name: 'Zazzle', url: 'https://www.zazzle.com/mbr/238822970296453680' },
      { name: 'Atlas Obscura', url: 'https://www.atlasobscura.com/users/goelst-france-sarl' },
      { name: 'ArtJobs', url: 'https://www.artjobs.com/users/goelstinternational' },
      { name: 'Experiment', url: 'https://experiment.com/users/goelstinternational' },
      { name: 'Dreevoo', url: 'https://dreevoo.com/profile_info.php?pid=2346363' },
      {
        name: 'Yoomark',
        url: 'https://yoomark.com/content/goelst-france-sarl-address-869-avenue-des-chenes-verts-bignoles-provence-alpes-cote-dazur',
      },
    ],
  },
  {
    id: 'annonces',
    title: 'Annonces et petites plateformes locales',
    description:
      'Annonces publiées localement pour signaler la disponibilité des solutions de rails à rideaux dans le Var et en région PACA.',
    links: [
      { name: 'AdsPostFree', url: 'https://adspostfree.com/ads/goelst-france-s-a-r-l/' },
      { name: 'GoLocalAds', url: 'https://www.golocalads.com/ads/goelst-france-s-a-r-l/' },
      { name: 'AdProceed', url: 'https://www.adproceed.com/ads/goelst-france-s-a-r-l/' },
      { name: 'The City Classified', url: 'https://www.thecityclassified.com/ads/goelst-france-s-a-r-l/' },
      { name: 'iFormative', url: 'https://www.iformative.com/product/goelst-france-sarl-p3133570.html' },
    ],
  },
]

export const totalResourceCount = resourceGroups.reduce((n, g) => n + g.links.length, 0)
